export default __webpack_public_path__ + "static/film_pl-89e85abc4690a22aa6301d20a8b789ab.mp4";